import React from "react";
import "./bfr.css";
import biometricImage from "../../../assets/service-pictures/biometric-and-facial.jpg";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import UseCases from "./UseCases";
import EnsureSecurity from "./EnsureSecurity";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";

const BiometricAndFacialRecognition = () => {
  return (
    <div className="bfr-service-wrapper">
      <Particles
        title="Biometric & Facial Recognition"
        image={biometricImage}
      />
      <HeroSection />
      <UseCases />
      <OurApproach />
      <EnsureSecurity />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default BiometricAndFacialRecognition;
